import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import useIsFabVisible from '@sprinx/react-mui-components/useIsFabVisible';
var ident = {
  name: 'SxPageHeadline'
};
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    title: _extends({}, theme.typography.h1, _defineProperty({
      flex: 'auto'
    }, theme.breakpoints.down('sm'), {
      paddingLeft: theme.spacing(1)
    })),
    shrink: _defineProperty({}, theme.breakpoints.up('md'), {
      paddingRight: theme.spacing(8)
    })
  };
}, ident);
/**
 * Komponent zahlavi stranky.
 *
 * @component
 */

function PageHeadline(_ref) {
  var actions = _ref.actions,
      children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      Component = _ref.component,
      TitleProps = _ref.TitleProps,
      rest = _objectWithoutProperties(_ref, ["actions", "children", "classes", "className", "component", "TitleProps"]);

  var fabVisible = useIsFabVisible();
  var classes = useStyles({
    classes: pClasses
  });
  return React.createElement("div", _extends({
    className: clsx(classes.root, fabVisible && classes.shrink)
  }, pickHTMLProps(rest)), React.createElement(Component, _extends({
    className: classes.title
  }, TitleProps), children), actions);
}

PageHeadline.propTypes = {
  /**
   * Akce stranky. Ocekavaji se instance komponenty `ToolbarActions`.
   */
  actions: PropTypes.node,

  /**
   * Obsah vlozeny do PageHeadline => node
   */
  children: PropTypes.node,
  classes: PropTypes.shape({
    root: PropTypes.string,
    shrink: PropTypes.string,
    title: PropTypes.string
  }),
  className: PropTypes.string,
  component: PropTypes.elementType,
  TitleProps: PropTypes.shape({})
};
PageHeadline.defaultProps = {
  actions: null,
  children: null,
  classes: undefined,
  className: undefined,
  component: 'h1',
  TitleProps: undefined
};
export default withThemeProps(ident)(PageHeadline);